import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { FeedLoadFulfilledAction } from '../../domains/feedLoad/actions.types';
import { NestedThreadLoadFulfilledAction } from '../../domains/nestedThread/types';
import { ThreadLoadFulfilledAction } from '../../domains/threadLoad/actions.types';
import { Feed, Thread } from '../types';

import { FeedOrThreadRequestOptions, FeedOrThreadRequestsOptions } from './types';

export type FeedRequestOptionsAction =
  | FeedLoadFulfilledAction
  | ThreadLoadFulfilledAction
  | NestedThreadLoadFulfilledAction;

const initialState: FeedOrThreadRequestsOptions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const captureNewFeedOptions = (state: FeedOrThreadRequestsOptions, payload: FeedLoadFulfilledAction['payload']) => {
  const wasRequestedAsNested = payload.wasRequestedAsNested;

  const feeds = payload.entities.feeds;

  const emptyAccumulator: Record<Feed['id'], FeedOrThreadRequestOptions> = {};

  const feedOrThreadRequestsOptions = Object.values(feeds).reduce((acc, feed) => {
    const requestOptions: FeedOrThreadRequestOptions = {
      id: feed.id,
      wasRequestedAsNested,
    };

    return {
      ...acc,
      [feed.id]: requestOptions,
    };
  }, emptyAccumulator);

  return moveToFulfilled(state, feedOrThreadRequestsOptions);
};

const captureNewThreadOptions = (
  state: FeedOrThreadRequestsOptions,
  payload: ThreadLoadFulfilledAction['payload'] | NestedThreadLoadFulfilledAction['payload'],
  wasRequestedAsNested: boolean
) => {
  const threads = payload.entities.threads;

  const emptyAccumulator: Record<Thread['id'], FeedOrThreadRequestOptions> = {};

  const feedOrThreadRequestsOptions = Object.values(threads).reduce((acc, thread) => {
    const requestOptions: FeedOrThreadRequestOptions = {
      id: thread.id,
      wasRequestedAsNested,
    };

    return {
      ...acc,
      [thread.id]: requestOptions,
    };
  }, emptyAccumulator);

  return moveToFulfilled(state, feedOrThreadRequestsOptions);
};

const reducer: Reducer<FeedOrThreadRequestsOptions, FeedRequestOptionsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return captureNewFeedOptions(state, action.payload);
    case 'THREAD.LOAD_FULFILLED':
      return captureNewThreadOptions(state, action.payload, false);
    case 'NESTED_THREAD.LOAD_FULFILLED':
      return captureNewThreadOptions(state, action.payload, true);
    default:
      return state;
  }
};

export default reducer;
